export default "__VITE_ASSET__F1B9fMuJ__"